import React, { useState } from "react";
import { Tooltip, useMediaQuery } from "@mui/material";
import IconButton from "../utils/IconButton";
import { FaInfoCircle } from "react-icons/fa";

const TypingInfo = () => {
  const [open, setOpen] = useState(false);
  const isTouchDevice = useMediaQuery("(pointer: coarse)");

  const handleClick = () => {
    if (isTouchDevice) {
      setOpen(prev => !prev);
    }
  };

  const handleTooltipOpen = () => {
    if (!isTouchDevice) {
      setOpen(true);
    }
  };

  const handleTooltipClose = () => {
    if (!isTouchDevice) {
      setOpen(false);
    }
  };

  return (
    <Tooltip
      title={
        <div style={{ maxWidth: 350, padding: "25px" }}>
          <span style={{ whiteSpace: "pre-line", fontSize: "12px" }}>
            <strong>WPM - Words Per Minute</strong>{"\n"}
            <strong>KPM - Keystrokes Per Minute</strong>{"\n"}
            <strong>ACC - Accuracy</strong>{"\n \n"}

            <strong>WPM - </strong>{""}
            Waa tirada ereyada saxda ah ee aad qortay daqiiqad gudaheed. Ereyaasoo celcelis ahaan ka kooban 5 shibane. {""}

            <strong>Tusaale:</strong>{" "}
            Haddii aad qortay 60 erey daqiiqad gudaheed, WPM-kaagu waa 60.{"\n\n"}

            <strong>KPM - </strong>{""}
            Waa inta goor ee aad keyboard-kaaga gujisay daqiiqad gudaheed. Ha noqoto: (shibanayaal, calaamado, space, backspace).{""}

            <strong>Tusaale:</strong>{" "}
            Haddii aad 200 oo jeer gujisay keyboard-kaaga, KPM-kaagu waa 200.{"\n\n"}

            <strong>ACC - </strong>{""}
            Waa boqolkiiba inta erey ee aad saxday, marka loo eego dhammaan ereyadii aad ku tababaratay.{""}

            <strong>Tusaale:</strong>{" "}
            Haddii aad qortay 100 erey, 50 ka mid ahna sax yihiin, ACC waa 50%.
          </span>
        </div>
      }
      placement="top-start"
      open={open}
      onOpen={handleTooltipOpen}
      onClose={handleTooltipClose}
      componentsProps={{
        tooltip: {
          sx: {
            borderRadius: "30px",
          },
        },
      }}
    >
      <IconButton color="inherit" onClick={handleClick}>
        <FaInfoCircle className="support-me" fontSize="28px" />
      </IconButton>
    </Tooltip>
  );
};

export default TypingInfo;
